import { GlobalStyles } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import './assets/styles/fonts.css';
import { red } from "@mui/material/colors";

const theme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: red[500],
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          "& .MuiFormLabel-asterisk": {
            marginLeft: 0,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
  },
  palette: {
    background: {
    //  default: "#f4f6f8",
     default: "#e3e3e3",
      paper: "#fff",
    },
    primary: {
      main: "#250258",
    },
    secondary: {
      main: "#444444",
      gray1: "#444444",
    },
  },
  typography: {
    // fontFamily: "Roboto, Arial",
    // h1: {
    //   fontFamily: "Urbane-Light",
    // },
    // h2: {
    //   fontFamily: "Raleway",
    // },
    // h3: {
    //   fontFamily: "Raleway,  ",
    // },
    // h4: {
    //   fontFamily: "Raleway",
    // },
    // h5: {
    //   fontFamily: "Urban Demibold",
    // },
    // h6: {
    //   fontFamily: "Roboto",
    //   fontWeight: "500",
    // },
    h4: {
      fontFamily: "Urbane-Demibold",
    },
    body1: {
      fontFamily: "Urbane-Demibold",
    },
    body2: {
      fontFamily: "Urbane-Light",
    },
  },
  spacing: 4,
  shape: {
    borderRadius: 8,
  },
  shadows: [
    "none",
    "0px 4px 20px rgba(0, 0, 0, 0.1)",
    "0px 4px 6px rgba(0, 0, 0, 0.1)",
    "0px 4px 10px rgba(0, 0, 0, 0.1)",
    "0px 4px 15px rgba(0, 0, 0, 0.1)",
    "0px 4px 25px rgba(0, 0, 0, 0.1)",
    "0px 6px 30px rgba(0, 0, 0, 0.1)",
    "0px 8px 40px rgba(0, 0, 0, 0.1)",
    "0px 10px 50px rgba(0, 0, 0, 0.1)",
    "0px 12px 60px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
    "0px 14px 70px rgba(0, 0, 0, 0.1)",
  ],
});

const globalStyles = (
  <GlobalStyles
    styles={{
      body: {
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        fontFamily: "Urbane-Light",
        backgroundColor: "#f4f6f8",
      },
    }}
  />
);

export { theme, globalStyles };
